import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import type { OrderFormField } from "@web-app/pages/settings/FormBuilderTab/types";

import {
  getOrderFormConfig,
  updateOrderFormConfig,
} from "../services/orderFormConfig";

export const useOrderFormConfig = ({ enabled = true } = {}) => {
  return useQuery({
    enabled,
    queryFn: getOrderFormConfig,
    queryKey: ["orderFormConfig"],
    refetchOnWindowFocus: false,
  });
};

export const useUpdateOrderFormConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fields: OrderFormField[]) => updateOrderFormConfig(fields),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orderFormConfig"] });
    },
  });
};
